import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import TagInput from '@src/components/Widget/InputTag';
import {
  Form,
  Row,
  Col,
  Button,
  Select,
  Divider,
  Space,
  Input,
  message,
} from 'antd';
import _ from 'lodash';

export default function Attribution({
  attribution,
  setAttribution,
  form,
}: any) {
  const [nameAtt, setNameAtt] = useState('');

  const getMenu = () => {
    let atts = form
      .getFieldValue('attribution')
      .filter((i: any) => !!i)
      .map((item: any) => item.property);
    let menus = attribution
      .filter((item: any) => !atts.includes(item))
      .map((item: any) => ({
        label: item,
        value: item,
      }));
    return menus;
  };
  const addItem = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (attribution.includes(nameAtt)) {
      message.error('Thuộc tính đã tồn tại');
      return;
    }
    setAttribution([...attribution, nameAtt]);
    setNameAtt('');
  };

  return (
    <Form.List name='attribution'>
      {(fields, { add, remove }) => (
        <>
          <Row gutter={24}>
            <Col span={12}>
              {/* <Form.Item
                required
                label="Đặc điểm"
                labelCol={{ span: 4 }}
                labelAlign="left"
              >
                <Button
                  type="dashed"
                  onClick={() => add()}
                  style={{ width: "39%", marginLeft: -4 }}
                  icon={<PlusOutlined />}
                >
                  Thêm đặc điểm
                </Button>
              </Form.Item> */}
            </Col>
          </Row>
          {fields.map((field) => {
            return (
              <Row key={field.key} gutter={24}>
                <Col span={6}>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, curValues) => {
                      return !_.isEqual(
                        prevValues.attribution,
                        curValues.attribution
                      );
                    }}
                  >
                    {() => (
                      <Form.Item
                        {...field}
                        label='Thuộc tính'
                        name={[field.name, 'property']}
                        rules={[
                          { required: true, message: 'Missing property' },
                        ]}
                        labelCol={{ span: 8 }}
                        labelAlign='left'
                      >
                        <Select
                          disabled
                          dropdownRender={(menu) => (
                            <>
                              {menu}
                              <Divider style={{ margin: '8px 0' }} />
                              <Space style={{ padding: '0 8px 4px' }}>
                                <Input
                                  placeholder='Thuộc tính'
                                  value={nameAtt}
                                  onChange={(e) => setNameAtt(e.target.value)}
                                />
                                <Button
                                  type='link'
                                  icon={<PlusOutlined />}
                                  onClick={addItem}
                                >
                                  Thêm
                                </Button>
                              </Space>
                            </>
                          )}
                          options={getMenu()}
                        />
                      </Form.Item>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    {...field}
                    label='Giá trị'
                    name={[field.name, 'values']}
                    rules={[{ required: true, message: 'Missing value' }]}
                    labelCol={{ span: 4 }}
                    labelAlign='left'
                  >
                    <TagInput error='Thuộc tính' disabled />
                  </Form.Item>
                </Col>
                {/* <Col span={4}>
                  <MinusCircleOutlined
                    className="dynamic-delete-button"
                    onClick={() => remove(field.name)}
                    style={{ color: "red", marginTop: 10 }}
                  />
                </Col> */}
              </Row>
            );
          })}
        </>
      )}
    </Form.List>
  );
}
